import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import PeopleLink from "../components/people-link";
import HelmetWrapper from "../components/helmetWrapper";

const PeoplePage = ({
  data: {
    allMarkdownRemark: { edges }
  }
}) => {
  const currentPeople = edges
    .filter(
      edge =>
        !!edge.node.frontmatter.date &&
        edge.node.frontmatter.position !== "alumni" && edge.node.frontmatter.position !== "active"
    )
    .map(edge => <PeopleLink key={edge.node.id} data={edge.node} />);

  const prevPeople = edges
    .filter(
      edge =>
        !!edge.node.frontmatter.date &&
        edge.node.frontmatter.position === "alumni"
    )
    .map(edge => <PeopleLink key={edge.node.id} data={edge.node} />);

  const activePeople = edges
    .filter(
      edge =>
        !!edge.node.frontmatter.date &&
        edge.node.frontmatter.position === "active"
    )
    .map(edge => <PeopleLink key={edge.node.id} data={edge.node} />);

  console.log(edges);

  return (
    <Layout>
      <HelmetWrapper
        title="People"
        description="The people of COCONUT Computer Club come from diverse backgrounds: professionals, students, and researchers from different industries, campuses, ethnicities, and religions, because we value diversity and prioritize collaboration."
        slug="/people"
      />
      <h1>People</h1>
      <div className="primary-content">
        The people here come from professionals, students, and researchers
        from different industries and campuses, as well as different
        ethnicities and religions, because we value diversity and prioritize
        collaboration.
      </div>
      <div className="grids small people-grids" style={{ marginBottom: "32px" }}>
        {currentPeople}
      </div>
      <h2>Active Members</h2>
      <div className="grids small people-grids" style={{ marginBottom: "32px" }}>
        {activePeople}
      </div>
      <h2>Previous lab members</h2>
      <div className="grids small people-grids" style={{ marginBottom: "32px" }}>
        {prevPeople}
      </div>
    </Layout>
  );
};

export default PeoplePage;
export const pageQuery = graphql`
  query peoplePageQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
    allMarkdownRemark(
      sort: { order: ASC, fields: [frontmatter___order] }
      filter: { frontmatter: { path: { regex: "/people/" } } }
    ) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            path
            title
            thumbnail
            metaDescription
            position
            endYear
          }
        }
      }
    }
  }
`;
